import { render, staticRenderFns } from "./chevron-right.vue?vue&type=template&id=3b47c6f6"
import script from "./chevron-right.vue?vue&type=script&lang=js"
export * from "./chevron-right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports